export default __webpack_public_path__ + "static/media/work_blog-top.b1e625de.jpg";